import React, { Component } from "react";
import appConstant from "../../../../../../appConstants";
import { withStyles } from "@material-ui/core";
import {
  convertDateTimeToTimeString,
  isTimeValid,
} from '@dataGrid/gridUtilities';
import StyledDateTimeEditor from "./StyledDateTimeEditor";
import { getStopTime } from "./utils";

const BACKSPACE_KEYCODE = 8

const styles = (theme) => ({
  stopTimeContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 16,
  },
  itemContainer: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.TextColor,
    opacity: 0.6,
    marginBottom: 4,
  },
  value: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    marginTop: 16,
  },
  errorText: {
    color: theme.errorBorderColor,
    fontSize: theme.textFontSize,
    maxWidth: 80,
  },
});


class StopWindowDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInvalidArrivalTime: false,
      isInvalidDepartureTime: false,
    };
  }


  handleOnDepartureKeyDown = (e) => {
    const { isInvalidDepartureTime } = this.state;
    const { departureTime } = this.props;

    /* we need to check keycode here , as we will want to retain the error of departure time
     which is less than arrival time , if there is no change in time 
    */
    if (departureTime && e.keyCode !== BACKSPACE_KEYCODE) {
      return;
    }
    !isInvalidDepartureTime &&
      this.setState({
        isInvalidDepartureTime: true,
      });
  };

  handleOnArrivalKeyDown = () => {
    const { isInvalidArrivalTime } = this.state;

    !isInvalidArrivalTime &&
      this.setState({
        isInvalidArrivalTime: true,
      });
  };

  handleOnArrivalChange = (value) => {
    const { arrivalTime, handleChange } = this.props;
    if (value === arrivalTime) {
      return;
    }
    if (!value || isTimeValid(convertDateTimeToTimeString(value))) {
      this.setState(
        {
          isInvalidArrivalTime: false,
        },
        handleChange?.("arrivalTime")(value)
      );
    }
  };

  handleOnDepartureChange = (value) => {
    const { departureTime, handleChange } = this.props;
    if (value === departureTime) {
      return;
    }
    if (!value || isTimeValid(convertDateTimeToTimeString(value))) {
      this.setState(
        {
          isInvalidDepartureTime: false,
        },
        handleChange?.("departureTime")(value)
      );
    }
  };

  renderReadOnlyValue = (classes, value) => {
    return <div className={classes.value}>{value}</div>;
  };

  getFormattedArrivalAndDepartureTime = () => {
    const {arrivalTime, departureTime, isReadOnly} = this.props;
    if (isReadOnly) {
      return {arrivalTime, departureTime}
    }
    return {
      arrivalTime: convertDateTimeToTimeString(arrivalTime),
      departureTime: convertDateTimeToTimeString(departureTime)
    }
  }

  render() {
    const {
      isArrivalTimeDisabled,
      arrivalTimeError,
      departureTimeError,
      timeWindow,
      timeWindowLabel,
      classes,
      isReadOnly,
    } = this.props;
    const { isInvalidArrivalTime, isInvalidDepartureTime } = this.state;
    const {arrivalTime, departureTime} = this.getFormattedArrivalAndDepartureTime();
    const stopTime = getStopTime(arrivalTime, departureTime);
    return (
      <div className={classes.stopTimeContainer}>
        <div className={classes.itemContainer}>
          <span className={classes.label}>{timeWindowLabel}</span>
          <span className={classes.value}>{timeWindow || "__:__"}</span>
        </div>
        <div className={classes.itemContainer}>
          <span className={classes.label}>Arrival Time</span>
          {isReadOnly ? (
            this.renderReadOnlyValue(
              classes,
              arrivalTime
            )
          ) : (
            <>
              <StyledDateTimeEditor
                disabled={Boolean(this.props.disabled || isArrivalTimeDisabled)}
                dateType={appConstant.DATETYPES.TIME}
                value={arrivalTime}
                onChange={this.handleOnArrivalChange}
                disableFocusInput
                enablePickerPortal
                onKeyDown={this.handleOnArrivalKeyDown}
              />
              {!isInvalidArrivalTime && arrivalTimeError && (
                <span className={classes.errorText}>{arrivalTimeError}</span>
              )}
            </>
          )}
        </div>
        <div className={classes.itemContainer}>
          <span className={classes.label}>Departure Time</span>
          {isReadOnly ? (
            this.renderReadOnlyValue(
              classes,
              departureTime
            )
          ) : (
            <>
              <StyledDateTimeEditor
                disabled={this.props.disabled}
                dateType={appConstant.DATETYPES.TIME}
                value={departureTime}
                onChange={this.handleOnDepartureChange}
                disableFocusInput
                enablePickerPortal
                onKeyDown={this.handleOnDepartureKeyDown}
              />
              {!isInvalidDepartureTime && departureTimeError && (
                <span className={classes.errorText}>{departureTimeError}</span>
              )}
            </>
          )}
        </div>
        <div className={classes.itemContainer}>
          <span className={classes.label}>Stop Time</span>
          <span className={classes.value}>
            {stopTime ? `${stopTime} mins` : ""}
          </span>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(StopWindowDetails);
